import * as APITypes from '../API';
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const customListTeams = /* GraphQL */ `
  query customListTeams($filter: ModelTeamFilterInput, $limit: Int, $nextToken: String) {
    listTeams(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        image {
          fileKey
          fileName {
            encoding
            filename
            mimeType
          }
          fileSize
          url
        }
        moduleConfigurations {
          processModuleID
          processModuleName
          processModuleDescription
          enabled
          forms {
            formID
            formName
            enabled
            customSettings
          }
          __typename
        }
        projects {
          nextToken
          items {
            id
            name
            teamId
            buckets
            canvases {
              items {
                id
                name
                lowercaseName
                teamId
                projectId
                createdAt
                updatedAt
                owner
                channelId
                properties
                ownerEmail
                adminGroups
                editorGroups
                viewerGroups
                managerGroups
                __typename
              }
              nextToken
              __typename
            }
            readiness
            createdAt
            updatedAt
          }
        }
        fileUrl
        color
        createdAt
        updatedAt
        adminGroups
        editorGroups
        viewerGroups
        managerGroups
        teamFlags
        address
        description
        teamSize
        phoneNumber
        valueProposition
        owner
      }
      nextToken
    }
  }
`;

export const basicListTeams = /* GraphQL */ `
  query basicListTeams($filter: ModelTeamFilterInput, $limit: Int, $nextToken: String) {
    listTeams(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        image {
          fileKey
          fileName {
            encoding
            filename
            mimeType
          }
          fileSize
          url
        }
        projects {
          nextToken
          items {
            id
            name
            teamId
            buckets
            canvases {
              items {
                id
                name
                lowercaseName
                teamId
                projectId
                createdAt
                updatedAt
                owner
                channelId
                properties
                ownerEmail
                adminGroups
                editorGroups
                viewerGroups
                managerGroups
                __typename
              }
              nextToken
              __typename
            }
            readiness
            createdAt
            updatedAt
          }
        }
        fileUrl
        color
        createdAt
        updatedAt
        adminGroups
        editorGroups
        viewerGroups
        managerGroups
        teamFlags
        address
        description
        teamSize
        phoneNumber
        valueProposition
        owner
      }
      nextToken
    }
  }
`;
